import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <p className="text-xs text-foreground-400 font-label font-medium uppercase tracking-widest mb-3">
            {t('allCategories')}
          </p>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-900 font-bold leading-tight">
            {t('categoriesTitle')}
            <br />
            {t('categoriesSubtitle')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-start gap-4 p-5 md:p-6 bg-background-50 rounded-lg hover:bg-accent-50 transition-all duration-300 cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 group-hover:bg-accent-100 transition-colors duration-300 shrink-0">
                <i className={`${cat.icon} text-lg text-foreground-600 group-hover:text-accent-500 transition-colors duration-300`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-label font-semibold text-foreground-900 text-sm md:text-base mb-1 group-hover:text-accent-600 transition-colors duration-300">
                  {cat.nameRu}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 font-body">
                  {cat.description}
                </p>
              </div>
              <span className="w-6 h-6 flex items-center justify-center shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-up-line text-accent-500 text-sm"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}